'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AVATAR_LOOKUP_PROPTYPES = exports.OBJECT_TYPES_THAT_REQUIRE_PORTAL_ID = exports.OBJECT_TYPE_TO_ENDPOINT_MAPPINGS = exports.DEFAULT_MAX_UPLOAD_SIZE_MB = exports.API_IDENTIFIER_MAPPINGS = exports.API_KNOWN_VALUE_MAPPINGS = exports.API_KNOWN_KEY_MAPPINGS = exports.RETINA_MULTIPLIER = exports.AVATAR_TYPE_ICONS = exports.AVATAR_TYPES = exports.AVATAR_SIZES = exports.SIZE_CLASSES = exports.BORDERWIDTH = exports.SOCIAL_MAP = undefined;

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _colors = require('HubStyleTokens/colors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SOCIAL_MAP = exports.SOCIAL_MAP = {
  facebook: { icon: 'socialFacebook', color: _colors.FACEBOOK },
  google: { icon: 'socialGoogle', color: _colors.GOOGLE },
  googledrive: { icon: 'socialGoogleDrive', color: _colors.GOOGLE },
  googleplus: { icon: 'socialGoogleplus', color: _colors.GOOGLE },
  heart: { icon: 'socialHeart', color: _colors.CANDY_APPLE },
  instagram: { icon: 'socialInstagram', color: _colors.INSTAGRAM },
  linkedin: { icon: 'socialLinkedin', color: _colors.LINKEDIN },
  pinterest: { icon: 'socialInstagram', color: _colors.PINTEREST },
  retweet: { icon: 'socialRetweet', color: _colors.TWITTER },
  rss: { icon: 'socialRss', color: _colors.RSS },
  slack: { icon: 'socialSlack', color: _colors.FACEBOOK },
  twitter: { icon: 'socialTwitter', color: _colors.TWITTER },
  xing: { icon: 'socialXing', color: _colors.XING },
  youtube: { icon: 'socialBlockYoutubeplay', color: _colors.YOUTUBE },
  youtubeplay: { icon: 'socialYoutubeplay', color: _colors.YOUTUBE }
};

var BORDERWIDTH = exports.BORDERWIDTH = 1;

var SIZE_CLASSES = exports.SIZE_CLASSES = {
  responsive: '',
  xs: 'private-avatar--xs',
  sm: 'uiAvatarSmall private-avatar--sm',
  md: 'uiAvatarMedium private-avatar--md',
  lg: 'uiAvatarLarge private-avatar--lg',
  xl: 'uiAvatarXLarge private-avatar--xl'
};

var AVATAR_SIZES = exports.AVATAR_SIZES = {
  xxs: 16,
  xs: 24,
  sm: 32,
  md: 48,
  lg: 72,
  xl: 108,
  responsive: 'responsive'
};

var AVATAR_TYPES = exports.AVATAR_TYPES = {
  company: 'COMPANIES',
  companyId: 'COMPANIES',
  contact: 'CONTACT',
  domain: 'COMPANIES',
  email: 'CONTACT',
  emails: 'CONTACT',
  enrichmentDomain: 'COMPANIES',
  enrichmentEmail: 'CONTACT',
  hubSpotUserEmail: 'CONTACT',
  hubSpotUserEmails: 'CONTACT',
  productId: 'PRODUCT',
  vid: 'CONTACT',
  ticket: 'TICKET',
  deal: 'DEAL',
  _isHasMore: false
};

var AVATAR_TYPE_ICONS = exports.AVATAR_TYPE_ICONS = {
  COMPANIES: 'companies',
  CONTACT: 'contacts',
  PRODUCT: 'product',
  TICKET: 'ticket',
  DEAL: 'deals'
};

var RETINA_MULTIPLIER = exports.RETINA_MULTIPLIER = 2;
var API_KNOWN_KEY_MAPPINGS = exports.API_KNOWN_KEY_MAPPINGS = {
  contact: 'knownContacts',
  company: 'knownCompanies'
};

var API_KNOWN_VALUE_MAPPINGS = exports.API_KNOWN_VALUE_MAPPINGS = {
  contact: {
    primaryIdentifier: 'vid',
    secondaryIdentifier: 'email'
  },
  company: {
    primaryIdentifier: 'companyId',
    secondaryIdentifier: 'domain'
  }
};

var API_IDENTIFIER_MAPPINGS = exports.API_IDENTIFIER_MAPPINGS = {
  contact: 'vids',
  company: 'companyIds',
  vids: 'vids',
  vid: 'vids',
  companyId: 'companyIds',
  email: 'emails',
  domain: 'domains',
  enrichmentEmail: 'emails',
  enrichmentDomain: 'domains',
  hubSpotUserEmails: 'hubSpotUserEmails',
  hubSpotUserEmail: 'hubSpotUserEmails',
  product: 'productIds',
  productId: 'productIds',
  _isHasMore: false
};

var DEFAULT_MAX_UPLOAD_SIZE_MB = exports.DEFAULT_MAX_UPLOAD_SIZE_MB = 4;

var OBJECT_TYPE_TO_ENDPOINT_MAPPINGS = exports.OBJECT_TYPE_TO_ENDPOINT_MAPPINGS = {
  contact: 'contacts/vid',
  vid: 'contacts/vid',
  company: 'companies/companyId',
  companyId: 'companies/companyId',
  product: 'products/productId',
  productId: 'products/productId'
};

var OBJECT_TYPES_THAT_REQUIRE_PORTAL_ID = exports.OBJECT_TYPES_THAT_REQUIRE_PORTAL_ID = ['contact', 'vid', 'company', 'companyId', 'product', 'productId'];

var AVATAR_LOOKUP_PROPTYPES = exports.AVATAR_LOOKUP_PROPTYPES = _propTypes2.default.oneOfType([_propTypes2.default.shape({
  type: _propTypes2.default.oneOf(['contact']).isRequired,
  primaryIdentifier: _propTypes2.default.number.isRequired,
  secondaryIdentifier: _propTypes2.default.string,
  fileManagerKey: _propTypes2.default.string,
  displayName: _propTypes2.default.string
}).isRequired, _propTypes2.default.shape({
  type: _propTypes2.default.oneOf(['company']).isRequired,
  primaryIdentifier: _propTypes2.default.number.isRequired,
  secondaryIdentifier: _propTypes2.default.string,
  fileManagerKey: _propTypes2.default.string,
  displayName: _propTypes2.default.string
}).isRequired, _propTypes2.default.shape({
  type: _propTypes2.default.oneOf(['vid']).isRequired,
  primaryIdentifier: _propTypes2.default.number.isRequired,
  displayName: _propTypes2.default.string
}).isRequired, _propTypes2.default.shape({
  type: _propTypes2.default.oneOf(['companyId']).isRequired,
  primaryIdentifier: _propTypes2.default.number.isRequired,
  displayName: _propTypes2.default.string
}).isRequired, _propTypes2.default.shape({
  type: _propTypes2.default.oneOf(['email']).isRequired,
  primaryIdentifier: _propTypes2.default.string.isRequired,
  displayName: _propTypes2.default.string
}).isRequired, _propTypes2.default.shape({
  type: _propTypes2.default.oneOf(['domain']).isRequired,
  primaryIdentifier: _propTypes2.default.string.isRequired,
  displayName: _propTypes2.default.string
}).isRequired, _propTypes2.default.shape({
  type: _propTypes2.default.oneOf(['enrichmentEmail']).isRequired,
  primaryIdentifier: _propTypes2.default.string.isRequired,
  displayName: _propTypes2.default.string
}).isRequired, _propTypes2.default.shape({
  type: _propTypes2.default.oneOf(['enrichmentDomain']).isRequired,
  primaryIdentifier: _propTypes2.default.string.isRequired,
  displayName: _propTypes2.default.string
}).isRequired, _propTypes2.default.shape({
  type: _propTypes2.default.oneOf(['hubSpotUserEmail']).isRequired,
  primaryIdentifier: _propTypes2.default.string.isRequired,
  displayName: _propTypes2.default.string
}).isRequired]);


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-avatars/static-2.2292/js/Constants.js
// module id = 16
// module chunks = 177